import { useEffect, useReducer } from "react";
import { entryTimerRemainingMs, formatEntryTimerTenths } from "./entryTimer.js";
import "./EntryTimerCorner.css";

// Card #3614 -- the bell-to-entry countdown, in the board's bottom corner next to
// the QR. Renders nothing when the envelope carries no (usable) timer. Counts down
// locally off the payload's receive stamp (see entryTimer.js), re-rendering every
// 100 ms only while the timer is running. At/below zero it shows a blinking 0.0.
export const ENTRY_TIMER_TICK_MS = 100;

const nowMs = () => (typeof performance !== "undefined" ? performance.now() : Date.now());

export default function EntryTimerCorner({ entryTimer }) {
  const [, tick] = useReducer((n) => n + 1, 0);
  const running = entryTimer?.running === true;
  useEffect(() => {
    if (!running) return undefined;
    const id = setInterval(tick, ENTRY_TIMER_TICK_MS);
    return () => clearInterval(id);
  }, [running, entryTimer]);

  const remaining = entryTimerRemainingMs(entryTimer, nowMs());
  const text = formatEntryTimerTenths(remaining);
  if (text === null) return null;
  const expired = remaining <= 0;
  return (
    <div
      className={`entry-timer-corner${expired ? " entry-timer-corner--expired" : ""}`}
      data-testid="entry-timer"
      data-expired={expired ? "true" : "false"}
    >
      {text}
    </div>
  );
}
